module.exports = __webpack_public_path__ + "img/组5386@2x.95142426.png";